import { Calendar } from "lucide-react";
import projectAnalytics from "../../assets/images/project-tv-analytics.jpg";
import projectManufacturing from "../../assets/images/project-manufacturing.jpg";
import projectDx from "../../assets/images/project-dx.jpg";
import projectWebRenewal from "../../assets/images/project-web-renewal.jpg";
import projectHybridApp from "../../assets/images/project-hybrid-app.jpg";

function Projects() {
  const projects = [
    {
      title: "テレビCM視聴データ分析システム",
      description:
        "テックリードとして参画。Vue2からVue3への移行とVite化、Atomic Designに沿った再設計を主導し、ビルド速度と開発効率を改善。バックエンドのKotlin/Ktor側ではDB設計やAPI設計・実装も担当。",
      image: projectAnalytics,
      tags: ["Vue3", "TypeScript", "Kotlin", "PostgreSQL"],
      role: "テックリード",
      period: "2024年7月 - 現在",
    },
    {
      title: "生産計画管理システム",
      description:
        "スクラムチーム終盤から参画し、エラーハンドリング設計、i18n対応、UUID v7導入など品質・運用改善を担当。ビルド時間短縮やLint/Formatter見直しなど開発環境の最適化でリリースを後押し。",
      image: projectManufacturing,
      tags: ["Nuxt3", "Vue3", "TypeScript", "Hasura/GraphQL"],
      role: "フロントエンド",
      period: "2024年3月 - 2024年5月",
    },
    {
      title: "DXスキル診断システム / WEBサイト改修",
      description:
        "フロントエンドとバックエンドを担当。Figmaから要件を固めつつ、社内マイクロサービスとの連携やAWS基盤を活用した運用改善を実施。新規機能追加と既存運用保守を並行で推進。",
      image: projectDx,
      tags: ["Nuxt3", "React", "TypeScript", "PHP", "Go", "Ruby", "MySQL"],
      role: "フルスタック",
      period: "2023年6月 - 2024年2月",
    },
    {
      title: "WEBサイトリニューアル",
      description:
        "フロントエンドとAWS周りを担当。XDと仕様を確認しながらVue2+Nuxt2で実装を推進。リリース後は追加機能開発やECSスケーリング調整など運用改善も実施。",
      image: projectWebRenewal,
      tags: ["Nuxt2", "Vue2", "TypeScript", "AWS"],
      role: "フロントエンド",
      period: "2022年9月 - 2023年5月",
    },
    {
      title: "ハイブリッドアプリ開発",
      description:
        "WebView機能開発を中心にサーバーサイドやUIデザインまで幅広く担当。1週間スプリントでKPTを回しつつ、外部エンジニアのオンボーディングやレビューを主導し大型アップデートをリリース。",
      image: projectHybridApp,
      tags: ["PHP", "React", "Vue2", "AWS"],
      role: "フルスタック",
      period: "2019年12月 - 2022年8月",
    },
  ];

  return (
    <section
      id="projects"
      className="bg-blue-50 px-6 py-16 md:px-12 md:py-24 lg:px-24"
    >
      <div className="fade-in-section mx-auto max-w-7xl">
        <div className="mb-10 space-y-4 text-center md:mb-12">
          <div className="mb-12 text-center md:mb-16">
            <h2 className="mb-4 text-xl font-bold text-gray-900 md:text-2xl">
              プロジェクト実績
            </h2>
            <div className="mx-auto h-1 w-20 bg-blue-600"></div>
          </div>
          <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-gray-600">
            直近で参画したプロジェクトの一部を紹介しています。
            <br />
            役割や期間、成果の概要を抜粋して掲載しています。
          </p>
        </div>
        <div className="space-y-6 md:space-y-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className="fade-in-section overflow-hidden rounded-lg bg-white shadow-md transition-shadow hover:shadow-xl"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <div className="grid gap-6 md:grid-cols-2">
                <div className="relative h-[300px] md:h-[300px]">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex flex-col justify-center p-6">
                  <div className="mb-2 flex items-center gap-3 text-sm">
                    <span className="text-blue-600">{project.role}</span>
                    <span className="flex items-center gap-1 text-gray-500">
                      <Calendar className="h-4 w-4" aria-hidden="true" />
                      {project.period}
                    </span>
                  </div>
                  <h3 className="mb-3 text-gray-900">{project.title}</h3>
                  <p className="mb-4 text-gray-700">{project.description}</p>
                  <div className="mb-4 flex flex-wrap gap-2">
                    {project.tags.map((tag, tagIndex) => (
                      <span
                        key={tagIndex}
                        className="rounded-full bg-blue-100 px-3 py-1 text-sm text-blue-700"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
